// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../node_modules/.pnpm/css-loader@7.1.3_webpack@5.105.2_esbuild@0.28.1_postcss@8.5.23_/node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/.pnpm/css-loader@7.1.3_webpack@5.105.2_esbuild@0.28.1_postcss@8.5.23_/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.status-card {
  margin-top: 1rem;
  background: #fff;
  border-radius: 16px;
  border: 1px solid rgba(0, 0, 0, 0.04);
  box-shadow: 0 0.125rem 0.25rem rgba(0, 0, 0, 0.075);
  padding: 16px;
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.status-card__title {
  margin: 0;
  font-size: 1.35rem;
}

.status-card__text {
  margin: 0;
  color: #4a5568;
}

.status-card__actions {
  display: flex;
  justify-content: flex-end;
  gap: 10px;
  flex-wrap: wrap;
}`, "",{"version":3,"sources":["webpack://./projects/public/src/app/components/event-shared/status-card/status-card.component.scss"],"names":[],"mappings":"AACA;EACE,gBAAA;EACA,gBAAA;EACA,mBAAA;EACA,qCAAA;EACA,mDAAA;EACA,aAAA;EACA,aAAA;EACA,sBAAA;EACA,QAAA;AAAF;;AAGA;EACE,SAAA;EACA,kBAAA;AAAF;;AAGA;EACE,SAAA;EACA,cAAA;AAAF;;AAGA;EACE,aAAA;EACA,yBAAA;EACA,SAAA;EACA,eAAA;AAAF","sourcesContent":["// Same surface as the event cards (event-list-item) and the details card.\n.status-card {\n  margin-top: 1rem;\n  background: #fff;\n  border-radius: 16px;\n  border: 1px solid rgba(0, 0, 0, 0.04);\n  box-shadow: 0 0.125rem 0.25rem rgba(0, 0, 0, 0.075);\n  padding: 16px;\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n}\n\n.status-card__title {\n  margin: 0;\n  font-size: 1.35rem;\n}\n\n.status-card__text {\n  margin: 0;\n  color: #4a5568;\n}\n\n.status-card__actions {\n  display: flex;\n  justify-content: flex-end;\n  gap: 10px;\n  flex-wrap: wrap;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
